import React, {useState} from "react";
import {useAppState} from "src/app/state/StateProvider";
import {ButtonGroup, Dropdown, DropdownButton} from "react-bootstrap";
import styles from "./MenuGauche.scss";
import AppIcon from "src/commun/composants/AppIcon";
import {PointMenuDto} from "src/domain/User";
import {goToUrl} from "src/app/menu/menuutil";
import {useNavigate} from "react-router-dom";


export type ItemMenuGaucheProps = {
  pointMenuDto: PointMenuDto
}

export const ItemMenuGauche = ({ pointMenuDto }: ItemMenuGaucheProps) => {
  const direction = "end";
  const [{ langue }] = useAppState();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <DropdownButton
        as={ButtonGroup}
        key={direction}
        id={`dropdown-button-drop-${direction}`}
        drop={(pointMenuDto.menuItems && pointMenuDto.menuItems.length > 0) ? direction : undefined}
        show={(pointMenuDto.menuItems && pointMenuDto.menuItems.length > 0) ? show : false}
        onMouseOver={() => setShow(true)}
        onMouseOut={() => setShow(false)}
        title={
          <>
            <AppIcon name={pointMenuDto.code} size="22px" className={styles.iconsMenuGauche}/>
            {pointMenuDto.withNotification && <span className={`${styles.notifs} ${pointMenuDto.counter && styles.notifsWithCounter}`}>{pointMenuDto.counter ? pointMenuDto.counter : <>&nbsp;</>}</span>}
            {pointMenuDto.labels[langue]}
          </>}
        onClick={() => {
          if (pointMenuDto.url) {
            goToUrl(pointMenuDto.url, pointMenuDto.openInNewTab, navigate);
          }
        }}
        className={styles.dropdownBtn}
      >
        {pointMenuDto.menuItems && pointMenuDto.menuItems.length > 0 && pointMenuDto.menuItems.map((sousPointMenu, index) => (
          <Dropdown.Item
            key={"menuEnfant-" + index}
            eventKey="1"
            className={styles.sousPoint}
            onClick={() => {
              if (sousPointMenu.url) {
                goToUrl(sousPointMenu.url, sousPointMenu.openInNewTab, navigate);
              }
            }}>
            <>
              <AppIcon name={pointMenuDto.code} size="22px" className={styles.iconsMenuGauche}/>
              {sousPointMenu.withNotification && <span className={`${styles.notifs} ${sousPointMenu.counter && styles.notifsWithCounter}`}>{sousPointMenu.counter ? sousPointMenu.counter : <>&nbsp;</>}</span>}
              <span className={styles.sousPointLabel}>{sousPointMenu.labels[langue]}</span>
            </>
          </Dropdown.Item>
        ))
        }
      </DropdownButton>
    </div>
  );

};

const MenuGauche = () => {
  const [{ menuGauche }] = useAppState();

  return (
    <div className={styles.menuGaucheContainer}>
      {(menuGauche ||[]).map((pointMenuDto: PointMenuDto, index) => (
        <ItemMenuGauche key={"itemMenuGauche-" + index} pointMenuDto={pointMenuDto}/>
      ))}
    </div>
  );
};

export default MenuGauche;